import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {DialogContent, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {bool, func} from 'prop-types';

import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';

const UpdateSubscriptionModal = ({isOpen, onClose}) => {
  return (
    <BaseModal hasCloseIcon open={isOpen} title="Abonnement mis à jour" onClose={onClose}>
      <DialogContent sx={{p: 3}}>
        <Grid container flexDirection="column" alignItems="center">
          <CheckCircleIcon sx={{fontSize: 64, mb: 2}} color="success" />
          <Typography variant="h6" fontWeight="bold" mb={3}>
            Votre abonnement a bien été mis à jour !
          </Typography>

          <Button variant="contained" color="secondary" onClick={onClose}>
            J'ai compris
          </Button>
        </Grid>
      </DialogContent>
    </BaseModal>
  );
};

UpdateSubscriptionModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired
};

export default UpdateSubscriptionModal;
